import { fcaFastApi, fcaGateWay } from "../../services/authorizationService";
import * as serviceEndpoints from "../../config/serviceEndPoints";

export const getAllMobileRecommendations = (params, isReport = false) => {
    let responseTypes = {};
    if (isReport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getAllMobileRecommendations}`, { params, ...responseTypes });
};

export const getMobileRecommendationById = id => fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getAllMobileRecommendations}/${id}`);

export const getRecommendationVideos = (id, params) => fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getAssetVideos}/${id}`, { params });

export const getMobileRecommendationTemplate = id =>
    fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getMobileRecommendationTemplate}/${id}`);

export const getMobileRecommendationDropdowns = (entity, params, asParam = false, is_project_based = false) => {
    const entityEndPoints = {
        asset_condition_id: params?.client_id
            ? `${serviceEndpoints.assetEndPoints?.dropdown?.asset_conditions}`
            : `${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${params}/asset_conditions_dropdown`,
        trade_id: `${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${params}/trades_dropdown`,
        category_id: `${serviceEndpoints.recommendationEndPoints.getCategoryBasedOnProject}/${params}/categories_dropdown`,
        recommendation_capital_type_id: `${serviceEndpoints.recommendationEndPoints.getCapitalTypeBasedOnProject}/${params}/capital_types_dropdown`,
        funding_source_id: `${serviceEndpoints.recommendationEndPoints.getFundingSourceByProject}/${params}/funding_sources_dropdown`,
        responsibility_id: `${serviceEndpoints.recommendationEndPoints.getFundingSourceByProject}/${params}/responsibilities_dropdown`,
        initiative_id: `${serviceEndpoints.recommendationEndPoints.getInitiativeDropdown}`,
        region_id: `${serviceEndpoints.projectEndPoints.getRegionsBasedOnClient}/${params}/regions`,
        site_id: is_project_based
            ? `${serviceEndpoints.recommendationEndPoints?.siteDropdownByProject}/${params?.project_id}/sites_dropdown`
            : `${serviceEndpoints.buildingEndPoints.getSitesBasedOnRegion}/${params}/site_dropdown`,
        floor: `${serviceEndpoints.recommendationEndPoints.getFloorBasedOnBuilding}/${params}/floors_dropdown`,
        addition_id: `${serviceEndpoints.recommendationEndPoints.getAdditionBasedOnBuilding}/${params}/additions_dropdown`,
        building_id: is_project_based
            ? `${serviceEndpoints.recommendationEndPoints?.buildingDropdownByProject}/${params?.project_id}/buildings_dropdown`
            : `${serviceEndpoints.additionEndPoints.getAllBuildingsDropdown}/buildings_dropdown`,
        system_id: `${serviceEndpoints.recommendationEndPoints.getSystemBasedOnProject}/${
            params?.project_id ? params?.project_id : params
        }/systems_dropdown`,
        sub_system_id: `${serviceEndpoints.recommendationEndPoints.getSubSystemBasedOnProject}/${
            params?.project_id ? params?.project_id : params
        }/sub_systems_dropdown`,
        criticality_id: `${serviceEndpoints.projectEndPoints.getCriticalityData}/${params}/criticalities`,
        department_id: `${serviceEndpoints.projectEndPoints.getDepartmentByProject}/${params}/departments_dropdown`,
        main_building_type_id: `${serviceEndpoints.buildingEndPoints.getBuildingTypesBasedOnClient}/building_types_dropdown`
    };
    return fcaGateWay.get(entityEndPoints?.[entity], asParam && { params });
};

export const updateMobileRecommendationFields = (id, params, source) =>
    source === "line_edit"
        ? fcaFastApi.put(`${serviceEndpoints.recommendationEndPoints.lineEditMobileRecommendation}/${id}`, params)
        : fcaFastApi.put(`${serviceEndpoints.recommendationEndPoints.updateMobileRecommendationFields}/${id}`, params);

export const getMobileRecommendationCommonDataByIds = params =>
    fcaFastApi.post(`${serviceEndpoints.assetSurveyProjectsEndPoints.getMobileRecommendationCommonDataByIds}`, params);

export const handleMultiMobileRecommendationUpdate = params =>
    fcaFastApi.post(`${serviceEndpoints.recommendationEndPoints.handleMultiMobileRecommendationUpdate}`, params);

export const getAllMobileRecommendationIds = (id, params) =>
    fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getAllMobileRecommendationIds}/${id}`, { params });

export const getMobileRecommendationFilterDropdown = params =>
    fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getMobileRecommendationFilterDropdown}/`, { params });

export const getListForMobileRecommendationFilter = params =>
    fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getMobileRecommendationFilterDropdown}/`, { params });

export const MobileRecomactivityLogRestore = id => fcaFastApi.post(`${serviceEndpoints.recommendationEndPoints.restoreActivityLog}/${id}`);

export const getMobileRecommendationsSummaryExports = (params, isReport = false) => {
    let responseTypes = {};
    if (isReport) {
        responseTypes = { responseType: "blob" };
    }
    return fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getMobileRecommendationsSummaryExports}`, { params, ...responseTypes });
};

export const getTableSummaryData = params => {
    return fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getTableSummary}`, { params });
};

export const getAiAnalyseKey = params => {
    return fcaFastApi.post(`${serviceEndpoints.recommendationEndPoints.getAiAnalyseKey}`, { params });
};

export const getGroupEditProgress = (id, params) => {
    return fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.getGroupEditProgress}${id}`, { params });
};

export const searchAndReplaceMobileRecommendation = params =>
    fcaFastApi.post(`${serviceEndpoints.recommendationEndPoints.mobileRecomSearchAndReplace}`, params);

export const findMobileRecommendationsBeforeReplace = params =>
    fcaFastApi.post(`${serviceEndpoints.recommendationEndPoints.mobileRecomSearchAndReplace}`, params);

export const revertRecom = id => {
    return fcaFastApi.put(`${serviceEndpoints.recommendationEndPoints.revertRecom}/${id}`);
};

export const revertRecomDataById = id => {
    return fcaFastApi.get(`${serviceEndpoints.recommendationEndPoints.revertRecomDataById}/${id}`);
};
